var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaim({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-70 -404) translate(50 238) translate(0 156) translate(20 11)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.545 6.364L.91 10m0-7.273l3.636 3.637"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.545,
    cy: 3.636,
    r: 3.636
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12.415c0-2.84-2.442-5.142-5.455-5.142-3.012 0-5.454 2.302-5.454 5.142 0 2.84 10.909 2.84 10.909 0z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaim);
export default __webpack_public_path__ + "static/media/claim.63bacdd36ddf59fd43424789aadbbe32.svg";
export { ForwardRef as ReactComponent };